import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

import { DataService, HTTPService, HelperService, DateService } from 'app/services';

import { templateTypes } from 'app/constants/templates/template-type';

@Component({
  selector: 'app-cancel-appt-dialog',
  templateUrl: './cancel-appt-dialog.component.html',
  styleUrls: ['./cancel-appt-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService],
})
export class CancelApptDialogComponent implements OnInit {
  data: any = {};
  content: string = '';
  templateData: any = {};
  isDataReceived: boolean = false;
  timezones: any = {};

  constructor(
    public dataService: DataService,
    public dateService: DateService,
    public dConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private httpService: HTTPService,
    private helperService: HelperService
  ) { }

  ngOnInit() {
    this.data = this.dConfig.data;
    this.isDataReceived = false;
    this.httpService.getTemplatesByTypeLang(templateTypes.cancel, this.dConfig.data.currentLang).then(
      (template) => {
        const { companyId } = this.helperService.getCompany();
        this.httpService.getCompanyDetails(companyId, 'fetchTimezones=true').then(
          (company) => {
            this.timezones = company && company.timezones;
            if (this.data.refetch) {
              this.httpService.getAppointmentById(this.data._id).then(
                (appointment) => {
                  this.content = template.contents;
                  this.templateData = {
                    company,
                    isEmail: appointment.isEmail,
                    isSMS: appointment.isSMS,
                    _id: appointment._id,
                    customer: (appointment.customer && appointment.customer.customerId) || {},
                    vehicle: (appointment.vehicle && appointment.vehicle.vehicleId) || {},
                    appointment: {
                      ...appointment,
                      startDate: this.helperService.dateFormatMMMDDYY(appointment.start),
                      startTime: this.helperService.dateFormathhmma(appointment.start),
                      endDate: this.helperService.dateFormatMMMDDYY(appointment.end),
                      endTime: this.helperService.dateFormathhmma(appointment.end),
                    },
                  };

                  this.content = this.helperService.templateParser(this.content, this.templateData, undefined, undefined, this.dConfig.data.currentLang);
                  this.isDataReceived = true;
                },
                (err) => {
                  this.helperService.showToaster('error', err);
                }
              );
            } else {
              this.content = template.contents;
              this.templateData = {
                company,
                customer: (this.data.appointment && this.data.appointment.customer) || {},
                vehicle: (this.data.appointment && this.data.appointment.vehicle) || {},
                appointment: {
                  ...this.data.appointment,
                  startDate: this.data.startDate,
                  startTime: this.data.startTime,
                  endDate: this.data.endDate,
                  endTime: this.data.endTime,
                },
              };
              this.content = this.helperService.templateParser(this.content, this.templateData, undefined, undefined, this.dConfig.data.currentLang);
              this.isDataReceived = true;
            }
          },
          (err) => {
            this.helperService.showToaster('error', err);
          }
        );
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  onClose(type) {
    this.dynamicDialogRef.close({
      type,
      data: {
        ...this.templateData,
        content: this.helperService.revertTemplateParsing(this.content, this.templateData),
      },
    });
  }
}
